import { Wallet, Lifesaver } from "@sapphire/icons/react";
import { Icon, View, tokens } from "@sapphire-react/core";
import styled from "styled-components";
import { useLoanInsuranceForm } from "../hooks/useLoanInsuranceForm";
import { AmountInputField } from "./AmountField";

type FormProps = {
  form: ReturnType<typeof useLoanInsuranceForm>;
};

export const Form = ({ form }: FormProps) => {
  const { control, ageFieldRules, trackCalculatorStarted } = form;

  return (
    <S.Form autoComplete={"off"} onClick={trackCalculatorStarted}>
      <View marginBottom={tokens.size.spacingMd}>
        <AmountInputField
          control={control}
          name={"age"}
          label={"Hur gammal är du?"}
          width={"100%"}
          data-cblabel={"Hur gammal är du?"}
          marginTop={tokens.size.spacingMd.value}
          min={18}
          max={63}
          rules={ageFieldRules}
          note={"Ange din ålder mellan 18 och 63 år"}
        />
      </View>
      <View marginBottom={tokens.size.spacingMd}>
        <AmountInputField
          control={control}
          name={"paymentProtection"}
          label={"Betalskydd"}
          width={"100%"}
          data-cblabel={"Betalskydd"}
          marginTop={tokens.size.spacingMd.value}
          postfix={"kr"}
          min={0}
          max={20_000}
          note={"Ange beloppet du vill försäkra (upp till 20 000 kr/mån)"}
          prefix={
            <Icon size={"md"}>
              <Wallet />
            </Icon>
          }
          rules={{
            min: {
              value: 0,
              message: "Ange ett belopp mellan 0 - 20 000 kr",
            },
            max: {
              value: 20_000,
              message: "Ange ett belopp mellan 0 - 20 000 kr",
            },
          }}
        />
      </View>

      <View marginBottom={tokens.size.spacingMd}>
        <AmountInputField
          control={control}
          name={"lifeProtection"}
          label={"Livskydd"}
          width={"100%"}
          data-cblabel={"Livskydd"}
          marginTop={tokens.size.spacingMd.value}
          postfix={"kr"}
          min={0}
          max={4_000_000}
          note={"Ange beloppet du vill försäkra (100 000 - 4 000 000 kr)"}
          prefix={
            <Icon size={"md"}>
              <Lifesaver />
            </Icon>
          }
          rules={{
            min: {
              value: 100_000,
              message:
                "Ange ett försäkrat belopp mellan 100 000 kr - 4 000 000 krr",
            },
            max: {
              value: 4_000_000,
              message:
                "Ange ett försäkrat belopp mellan 100 000 kr - 4 000 000 kr",
            },
          }}
        />
      </View>
    </S.Form>
  );
};

const S = {
  Form: styled.form`
    display: flex;
    flex-direction: column;
  `,
};
